module.exports = __webpack_public_path__ + "img/product-category-weddingrings.4d758a8.jpg";